var Slideshow = {

	init: function(){
		//What templates should trigger this module?
		var templates = [
			'.slideshow-flickity'
		].join();

		if (!$(templates).length) return;

		this.$slideshows = [];
		var self = this;

		$(templates).each(function( ) {

			var $slideshow = $( this ).flickity({
				contain:true,
				draggable:true,
				pageDots:false,
				wrapAround:true,
				prevNextButtons:true,
				touchVerticalScroll: false
			});

			self.$slideshows.push($slideshow);
		});
	},

	/*
	 * Prep for re-init
	 * @param	void
	 * @returns void
	 */
	drop: function(){
		this.$slideshows.each(function( ) {
			this.flickity('destroy');
		})
	}
}

module.exports = Slideshow;
